"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Github, Linkedin, Twitter } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const techStack = ["Math & Algebra", "Finance & Interest", "Unit Conversions", "Health & Fitness"];
  const socialLinks = [{
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }, {
    icon: Twitter,
    href: "#",
    label: "X (Twitter)"
  }, {
    icon: Github,
    href: "#",
    label: "GitHub"
  }];
  return <section data-section-id="236495" id="footer" className="dark bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          {}
          <div className="space-y-6">
            <Link to="/HomePage" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1600149/img/calculo_logo_dark.png" alt="CALCULO" className="h-7 w-auto" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed pr-4 font-default">
              Empowering precision through fast, accurate, and easy-to-use digital tools. Your comprehensive platform for math, finance, and conversion calculations.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground mb-6 text-lg tracking-tight">
              Top Categories
            </h3>
            <MenuProvider menu_id="68">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground mb-6 text-lg tracking-tight">
              Calculators
            </h3>
            <ul className="space-y-3">
              {techStack.map((tech, i) => <li key={tech} data-index={i} className="text-muted-foreground text-sm font-default">
                  {tech}
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground mb-6 text-lg tracking-tight">
              Connect
            </h3>
            <div className="flex space-x-5">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} data-index={i} to={social.href} className="text-muted-foreground hover:text-primary transition-colors duration-200" aria-label={social.label}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <Separator className="mb-8 bg-border opacity-50" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm font-default">
            &copy; {new Date().getFullYear()} CALCULO Precision Platform. All rights reserved.
          </p>
          <div className="flex space-x-6 text-sm text-muted-foreground font-default">
            <Link to="#" className="hover:text-primary transition-colors duration-200">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors duration-200">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}